import { handleActions } from "redux-actions";
import { setSiteGroups } from "services/SiteGroup/actions";

const initialState = {
    isLoading: false,
    codes: [],
    siteGroups: {}
};

export const siteGroupReducer = handleActions(
    {
        [setSiteGroups]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);